import { render, staticRenderFns } from "./BIReports.vue?vue&type=template&id=cfab1d4c&"
import script from "./BIReports.vue?vue&type=script&lang=ts&"
export * from "./BIReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports